import React from "react";
import AuthPage from "./AuthPage";

const AuthPageContainer: React.FC = ({ children }) => {
  return <AuthPage>{children}</AuthPage>;
};

export default AuthPageContainer;
